import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as SharedServices from '../shared';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    // SharedServices.CurrencyDirective
    
  ],
  imports: [
    CommonModule
  ],
  providers: [
    SharedServices.GetCMSDataService,
    DatePipe
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        SharedServices.GetCMSDataService,
        SharedServices.StartQuoteService,
        SharedServices.AnnuitantDetailService,
        SharedServices.QuoteDataCaptureService,
        SharedServices.GoogleRecaptchaV2Service
      ]
    };
  }
}
